import { useContext, useState, useCallback } from "react";
import { useLocation } from 'react-router-dom';

import { i18n } from "../../../translate/i18n";

import { Check, Text, Button } from "@aidron/aidron-ds";

import {
  ArrowModalButton,
  FilterButton,
  SortSelect 
} from "../sharedComponents.index";

import { CustomCard } from "../../StyledComponents/styleComponents.index";

import PropTypes from 'prop-types';
import { HierarchyFiltersSalesRecommendation } from "../../../modules/PurchaseManagementModule/SalesRecomendation/components/HierarchyFiltersSalesRecommendation/HierarchyFiltersSalesRecomendation";
import { TenantContext } from "../../../templates/context/TenantContext";
import { TENANT_CATEGORY } from "../../components.constants";

const { t } = i18n;

export function OpportunityOptions({ actions, ctx, uiState }) {

  const { hierarchy } = useContext(TenantContext);

  const [showFilters, setShowFilters] = useState(false);
  const [appliedFiltersCount, setAppliedFiltersCount] = useState(0);

  const { 
    setSelectedProductIds = () => {}, 
    toggleTypeFilter,
    setOrder, 
    setSelectedHierarchyFilters 
  } = actions || {};

  const { 
    productIds = [], 
    selectedProductIds,
    selectedTypes,
    products,
    typeOptions 
  } = ctx || {};

  const { order, orderingMode } = uiState || {};

  const location = useLocation();
  const currentPath = location.pathname;
  const label = currentPath.includes("produtos") ? t("opportunityType") : t("productFilter");

  const renderTypesFilter = useCallback(
    ({ closeModal }) => (
      <OpportunityOptions.TypesOfOpportunitiesFilter
        actions={{ toggleTypeFilter, closeModal }}
        ctx={{ typeOptions, selectedTypes }}
      />
    ),
    [toggleTypeFilter, typeOptions, selectedTypes]
  );

  return (
    <>
      <CustomCard margin="0 0 20px 0">
        <section style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', columnGap: '2%' }}>
          
          <FilterButton 
            actions={{ setShowFilters: setShowFilters }}
            uiState={{ appliedFiltersCount: appliedFiltersCount, showFilters: showFilters }}/>
          
          <div style={{ display: 'flex', gap: '5rem' }}>
            <ArrowModalButton
              label={label}
              size="lg"
              renderModalContent={renderTypesFilter}/>

            <SortSelect label={`${t("orderBy")}:`} selected={order} options={orderingMode} onChange={setOrder} />
          </div>
        </section>
      </CustomCard>

       <HierarchyFiltersSalesRecommendation 
        actions={{ 
          setSelectedProductIds: setSelectedProductIds, 
          setAppliedFiltersCount: setAppliedFiltersCount,
          setSelectedHierarchyFilters: setSelectedHierarchyFilters,
          setShowFilters: setShowFilters
        }}
        ctx={{ 
          productIds: productIds, 
          selectedProductIds: selectedProductIds,
          products: products,
          hierarchyNames: hierarchy
        }}
        uiState={{
          clientType: TENANT_CATEGORY.RETAIL,
          showFilters: showFilters
        }}
       /> 
    </>
  );
};

OpportunityOptions.TypesOfOpportunitiesFilter = OpportunityTypeFilter;

function OpportunityTypeFilter({ actions, ctx }) {

  const { toggleTypeFilter = () => {}, closeModal } = actions || {};
  const { typeOptions, selectedTypes } = ctx || {};

  return (
    <>
      {typeOptions.map(option => (
        <section style={{ display: 'flex', alignItems: 'center' }} key={option.value}>
          <Check 
            two 
            handleChange={() => toggleTypeFilter(option.value)} 
            value={selectedTypes?.includes(option.value) ? "1" : "0"} 
          />
          <Text weight="bold">{option.displayName}</Text>
        </section>
      ))}

      <div style={{ display: 'flex', justifyContent: 'end' }}>
        <Button label={t("done")} onClick={closeModal} />
      </div>
    </>
  );
};


OpportunityTypeFilter.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape(),
};

OpportunityOptions.propTypes = {
  actions: PropTypes.shape(),
  ctx: PropTypes.shape(),
  uiState: PropTypes.shape()
};